import { Component, OnInit } from '@angular/core';
import { UserService } from '../../shared/user.service';
import { ErrorHandler } from '../../shared/ErrorHandler';

@Component({
  selector: 'app-projectwise-client-list',
  templateUrl: './projectwise-client-list.component.html',
  styleUrls: ['./projectwise-client-list.component.css']
})
export class ProjectwiseClientListComponent implements OnInit {

  constructor(private userService: UserService,private errorHandler: ErrorHandler) { }

  ngOnInit() {
    this.ProjectwiseClientsCount();
  }

  ProjectwiseClientsCount = function(){
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.projectwiseClientsCount()
    .subscribe((data:any)=>{
      this.ProjectList = data;
      document.getElementById('loader-spinner').style.display = "none";
    },(error)=>{
      document.getElementById('loader-spinner').style.display = "none";
      this.errorHandler.HandlerError(error);
    });

}

}



// WEBPACK FOOTER //
// ./src/app/reports/projectwise-client-list/projectwise-client-list.component.ts